<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title="MAKLUMAT AGENSI PEMBAYAR">
            <w-form
                class=""
                v-model="form.valid"
                v-model:errors-count="form.errorsCount"
                @validate="simpan"
                @success="Success"
            >
                <div class="message-box">
                    <w-transition-fade>
                        <w-alert
                            class="my0 text-light"
                            v-if="form.submitted"
                            success
                            no-border
                        >
                            The form is valid, ready to send it!
                        </w-alert>

                        <w-alert
                            class="my0 text-light"
                            v-else-if="form.valid === false"
                            error
                            no-border
                        >
                            Terdapat {{ form.errorsCount }} ralat di dalam
                            borang ini.
                        </w-alert>
                    </w-transition-fade>
                </div>

                <w-dialog
                    v-model="dialog.show"
                    :fullscreen="dialog.fullscreen"
                    :width="dialog.width"
                    :persistent="dialog.persistent"
                    :persistent-no-animation="dialog.persistentNoAnimation"
                    title-class="primary-light1--bg white"
                >
                    <template #title> Tambah Profil </template>
                    <template #default>
                        <w-form
                            ref="form"
                            v-model="dialog.valid"
                            @validate="submitProfil"
                            @success="success"
                        >
                            
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    label="ID Pengenalan/No. Syarikat*"
                                    name="ID Pengenalan/No. Syarikat*"
                                    v-model="form_profil.no_id"
                                    :validators="[validators.required]"
                                />&nbsp;&nbsp;&nbsp;
                                <z-input
                                    label="Nama*"
                                    name="Nama*"
                                    v-model="form_profil.nama"
                                    :validators="[validators.required]"
                                />
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    label="Alamat"
                                    name="Alamat"
                                    v-model="form_profil.alamat1"
                                    :validators="[validators.required]"
                                />
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    name="Alamat"
                                    v-model="form_profil.alamat2"
                                />
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    name="Alamat"
                                    v-model="form_profil.alamat3"
                                />
                            </w-flex>
                            <z-lookup
                                label="Poskod"
                                name="poskod"
                                :url="service_deposit + 'lookup/lkp_poskod'"
                                :sort="false"
                                :cache="false"
                                v-model="form_profil.lkp_poskod_id"
                                :validators="[validators.required]"
                            /><br />
                            <w-flex
                                justify-center
                                align-center
                                v-if="form_profil.bandar"
                            >
                                <div class="xs6">
                                    <h5 class="fw-semibold m0">Bandar :</h5>
                                    {{ form_profil.bandar }}
                                </div>

                                <div class="xs6">
                                    <h5 class="fw-semibold m0">Negeri :</h5>
                                    {{ form_profil.negeri }}
                                </div>
                                <br />
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    label="No. Telefon"
                                    name="No. Telefon"
                                    v-model="form_profil.no_tel"
                                    :validators="[validators.numeric]"
                                />
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    label="Email"
                                    name="Email"
                                    v-model="form_profil.emel"
                                    
                                />
                            </w-flex>
                            <div class="title4 mb2">Kategori Profil*</div>
                            <w-radios :items="kategori" 
                                v-model="form_profil.kategori"
                                :sort="false"
                                :cache="false" 
                                :validators="[validators.required]"
                                inline></w-radios>
                        </w-form>
                    </template>
                    <template #actions>
                        <div class="spacer" />
                        <w-button
                            bg-color="grey-light5--bg"
                            @click="dialog.show = false"
                            >Tutup</w-button
                        >
                        <w-button
                            class="ml1"
                            :loading="dialog.loading"
                            :disabled="dialog.valid === false"
                            @click="$refs.form.validate()"
                            >Daftar</w-button
                        >
                    </template>
                </w-dialog>

                <w-card bg-color="" class="">
                <w-flex justify-center align-center>
                    <div class="xs4">
                        <h5 class="fw-semibold m0">Agensi </h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.pejabat }}
                        </div>
                    </div>

                    <div class="xs4">
                        <h5 class="fw-semibold m0">Kod Jabatan</h5>
                        <div class="fw-normal my1 fs-1">{{ form.kod }}</div>
                    </div>

                    <div class="xs4">
                      <h5 class="fw-semibold m0">Nama Jabatan</h5>
                        <div class="fw-normal my1 fs-1">
                            {{form.nama}}
                        </div>
                    </div>
                </w-flex>

                <w-flex justify-center align-center>
                  <div class="xs4">
                        <h5 class="fw-semibold m0">No Telefon</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.no_tel}}
                        </div>
                    </div>
                    

                    <div class="xs4">
                       <h5 class="fw-semibold m0">Emel</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.emel }}
                        </div>
                    </div>

                    <div class="xs4">
                        <h5 class="fw-semibold m0">
                            Alamat
                        </h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.lkp_poskod}},{{ form.lkp_bandar}}, {{ form.lkp_negeri}}
                        </div>
                    </div>
                </w-flex>
                </w-card><br><br>

                <!-- </w-from> -->
                <w-tabs :items="tabs" :no-slider="false" active-class="primary" v-model="activeTab">
                <template #item-content.1>
                    <!-- <h3>Nama Pemilik Perumahan *</h3> -->
                    <w-flex class="mt3">
                        <div class="xs11">
                            <z-input
                                label="Nama Pemilik Perumahan"
                                name="profil_id"
                                readonly
                                @click="profil"
                                :validators="[validators.required]"
                            />
                        </div>
                        <!-- <div class="xs1">&nbsp;
                            <w-icon @click="dialog.show = true">fal fa-plus</w-icon>
                        </div> -->
                    </w-flex>
                <br/>
                <br/>
                    <w-flex justify-center align-center>
                        <div class="w-card__content content-hardcode">
                            <table class="table-dashboard" width="100%">
                                <thead>
                                    <tr>
                                        <td>Bil</td>
                                        <td>Nama Pemotong Gaji</td>
                                        <td>Nama Pemilik Perumahan</td>
                                        <td>No Akaun</td>
                                        <td>Kod Premis</td>
                                        <td>Skim Perumahan</td>
                                        <td>Jenis Skim</td>
                                        <td>Kadar Bulanan (RM)</td>
                                        <td>Jumlah Patut Kutip (RM)</td>
                                        <td>Kadar Potongan Gaji (RM)</td>
                                        <td colspan="2">Tindakan&nbsp;&nbsp;<w-checkbox v-model="pilih" @click="cekPilih" class="mr2"></w-checkbox></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(dt, index) in form.perum_array">
                                        <!-- <td>{{index + 1}}</td> -->
                                        <td></td>
                                        <td>
                                            <template v-if ="dt.perumahan_profil_pembayar != '' ">
                                                <template v-for="(d, index) in dt.perumahan_profil_pembayar">
                                                        {{d.nama_id}}
                                                </template>
                                            </template>
                                            <template v-else>
                                                <template v-for="(d, index) in dt.perumahan_profil_peminjam">
                                                        {{d.nama_id}}
                                                </template>
                                            </template>
                                        </td>
                                        <td>
                                            <template v-for="(d, index) in dt.perumahan_profil_peminjam">
                                                    {{d.nama_id}}
                                            </template>
                                        </td>
                                        <td>{{dt.no_akaun}}</td>
                                        <td>{{dt.kod_premis}}</td>
                                        <td>{{dt.no_skim}}</td>
                                        <td>{{dt.lkp_perumahan_keterangan}}</td>
                                        <td>{{$zutil.currency(dt.jumlah_amaun_bil)}}</td>
                                        <td>{{$zutil.currency(dt.amaun_patut_kutip)}}</td>
                                        <td>{{$zutil.currency(dt.perumahan_potongan_amaun)}}</td> 
                                        <td class="align-center">
                                            &nbsp;&nbsp;
                                            <w-icon
                                                class="mr1"
                                                @click="padam(dt)"
                                                >fal fa-trash
                                            </w-icon>
                                        </td>
                                        <td>
                                            &nbsp;&nbsp;
                                            <template v-if="dt.jumlah_amaun_bil > 0">
                                                <w-checkbox v-model="dt.pilih"></w-checkbox>
                                            </template>
                                            <template v-else>
                                                Belum Terdapat Bil
                                            </template>
                                        </td>
                                    </tr>
                                    <tr v-for="(dt, index) in perumahan">
                                        <!-- <td>{{index + 1}}</td> -->
                                        <td></td>
                                        <td>
                                              <z-input
                                                name="profil_id"
                                                v-model="form.pembayar_nama"
                                                 @click="profilPembayar(dt)"
                                            />
                                        </td>
                                        <td>
                                            <!-- <template v-for="(d, index) in dt.perumahan_profil">
                                                <template v-if="d.lkp_perumahan_profil_id == 1"> -->
                                                    {{form.nama_profil}}
                                               <!--  </template>
                                            </template> -->
                                        </td>
                                        <td>{{dt.no_akaun}}</td>
                                        <td>{{dt.kod_premis}}</td>
                                        <td>{{dt.skim_perumahan}}</td>
                                        <td>{{dt.jenis_skim}}</td>
                                        <td>{{$zutil.currency(dt.jumlah_amaun_bil)}}</td>
                                        <td>{{$zutil.currency(dt.jumlah_patut_kutip)}}</td>
                                        <td>
                                            <z-money 
                                            outline
                                            v-model:originalValue="dt.kadar_potongan"
                                            :validators="[validators.required]">
                                          </z-money>
                                        </td>
                                        <td>
                                            <w-icon
                                                class="mr1"
                                                @click="removePerumahan(index)"
                                                >fal fa-trash</w-icon
                                            >&nbsp;&nbsp;
                                        </td>
                                        <td>
                                            
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </w-flex>

                <w-flex class="mt3" wrap align-center justify-end>
                    <w-button
                        class="my1"
                        bg-color="warning"
                        @click="back()"
                        >Kembali
                    </w-button>
                    &nbsp;&nbsp;&nbsp;
                    <template v-if="perumahan != null">
                    <w-button
                        class="my1"
                        type="submit"
                        :disabled="form.valid === false"
                        :loading="form.submitted && !form.sent"
                    >
                        <w-icon dark tile class="mr2">fal fa-save</w-icon>
                        Simpan
                    </w-button>
                    </template>
                    &nbsp;&nbsp;&nbsp;
                    <w-button
                        class="my1"
                        @click="bayar"
                    >
                        <w-icon dark tile class="mr2">fal fa-save</w-icon>
                        Bayar
                    </w-button>
                </w-flex>
                </template>
                <template #item-content.2>
                    <w-flex justify-center align-center>
                            <div class="w-card__content content-hardcode">
                                <table class="table-dashboard" width="100%">
                                    <thead>
                                        <tr>
                                            <td width="2%">No</td>
                                            <td width="15%">Tarikh</td>
                                            <td>Pengguna</td>
                                            <td>Status</td>
                                            <td>Catatan</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(dt, index ) in form.jejak_audit_pejabat" >
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ dt.tarikh }}</td>
                                            <td>{{ dt.user_nama }}</td>
                                            <td>
                                                {{ dt.tindakan_keterangan_perumahan_pejabat }}
                                            </td>
                                            <td>{{ dt.catatan }}</td>
                                        </tr>
                                        <tr v-if="form.jejak_audit.length == 0">
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </w-flex>
                </template>
                </w-tabs>
            </w-form>
            <w-dialog
                v-model="dialogProfil.show"
                :fullscreen="dialogProfil.fullscreen"
                :width="dialogProfil.width"
                :persistent="dialogProfil.persistent"
                :persistent-no-animation="dialogProfil.persistentNoAnimation"
                title-class="primary-light1--bg white"
            >
                <template #title>
                    <w-icon class="mr2">fal fa-user</w-icon>
                    Carian Profil
                </template>
                <div class="page-wrapper-portal">
                    <w-flex justify-center align-center>
                        <div class="xs8">
                            <w-input
                                label="No KP | Nama | Kod Premis"
                                v-model="carian_profil.q">
                            </w-input>
                        </div>
                        <div class="xs4">
                            <w-button 
                                class="ml1" 
                                @click="cariProfil">Cari
                            </w-button>
                        </div>
                    </w-flex>
                    <div class="table-profil-scrol">
                        <table class="w-table">
                            <thead>
                                <tr>
                                    <th class="w-table__header w-table__header--sortable text-left">
                                        No
                                    </th>
                                    <th class="w-table__header w-table__header--sortable text-left">
                                        No KP | Nama
                                    </th>
                                    <th class="w-table__header w-table__header--sortable text-left">
                                        Pilih
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(dt, index) in profils">
                                    <td class="w-table__cell text-left">
                                        {{ index + 1 }}
                                    </td>
                                    <td class="w-table__cell">
                                        {{ dt.label }}
                                    </td>
                                    <td class="w-table__cell text-right">
                                        <w-button
                                            class="my1"
                                            v-model="form.profil_id"
                                            @click="pilihProfil(dt)"
                                            >Pilih
                                        </w-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <template #actions>
                    <div class="spacer" />
                    <w-button
                        bg-color="grey-light5--bg"
                        @click="dialogProfil.show = false"
                        >Tutup
                    </w-button>
                </template>
            </w-dialog>
            <w-dialog
                v-model="dialogProfilPembayar.show"
                :fullscreen="dialogProfilPembayar.fullscreen"
                :width="dialogProfilPembayar.width"
                :persistent="dialogProfilPembayar.persistent"
                :persistent-no-animation="dialogProfilPembayar.persistentNoAnimation"
                title-class="primary-light1--bg white"
            >
                <template #title>
                    <w-icon class="mr2">fal fa-user</w-icon>
                    Carian Profil Pembayar
                </template>
                <div class="page-wrapper-portal">
                    <w-flex justify-center align-center>
                        <div class="xs8">
                            <w-input
                                label="No KP | Nama"
                                v-model="carian_profil_pembayar.q">
                            </w-input>
                        </div>
                        <div class="xs4">
                            <w-button 
                                class="ml1" 
                                @click="cariProfilPembayar">Cari
                            </w-button>
                            &nbsp;&nbsp;
                            <w-icon  @click="profilNew">fal fa-plus</w-icon>
                        </div>
                    </w-flex>
                    <div class="table-profil-scrol">
                        <table class="w-table">
                            <thead>
                                <tr>
                                    <th class="w-table__header w-table__header--sortable text-left">
                                        No
                                    </th>
                                    <th class="w-table__header w-table__header--sortable text-left">
                                        No KP | Nama
                                    </th>
                                    <th class="w-table__header w-table__header--sortable text-left">
                                        Pilih
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(dt, index) in profils_pembayar">
                                    <td class="w-table__cell text-left">
                                        {{ index + 1 }}
                                    </td>
                                    <td class="w-table__cell">
                                        {{ dt.label }}
                                    </td>
                                    <td class="w-table__cell text-right">
                                        <w-button
                                            class="my1"
                                            v-model="form.profil_id"
                                            @click="pilihProfilPembayar(dt)"
                                            >Pilih
                                        </w-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <template #actions>
                    <div class="spacer" />
                    <w-button
                        bg-color="grey-light5--bg"
                        @click="dialogProfilPembayar.show = false"
                        >Tutup
                    </w-button>
                </template>
            </w-dialog>

             <w-dialog v-model="dialogProfilNew.show" :fullscreen="dialog.fullscreen" :width="dialog.width" :persistent="dialog.persistent" :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-light1--bg white">
                <template #title>
                     Tambah Profil
                </template>
                <template #default>
                     <w-form ref="form" v-model="dialog.valid" @validate="submitProfilNew" @success="success">
                        <template ></template><br>

                        <w-flex justify-space-between class="mb4">
                            <div class="xs4">
                           <div class="title4 mb2">Kategori Profil*</div>
                            <w-radios :items="kategori" 
                                v-model="form_profil.kategori"
                                :sort="false"
                                :cache="false" 
                                :validators="[validators.required]"
                                inline></w-radios>
                            </div>

                           </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="No. KP/No. Syarikat *"  
                              name="No. ID" 
                              v-model="form_profil.no_id" 
                              :validators="[validators.required]"/>
                            <z-input 
                              label="Nama *" 
                              name="Nama" 
                              v-model="form_profil.nama" 
                              :validators="[validators.required]"/>
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="Alamat *" 
                              name="Alamat" 
                              v-model="form_profil.alamat1" 
                              :validators="[validators.required]"/>
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              name="Alamat2" 
                              v-model="form_profil.alamat2" />
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              name="Alamat3" 
                              v-model="form_profil.alamat3" />
                        </w-flex>
                        <z-lookup 
                              label="Poskod" 
                              name="poskod" 
                              :url='service_bil_pelbagai+"lookup/lkp_poskod"' 
                              :sort="false" :cache="false"
                              v-model="form_profil.lkp_poskod_id"/><br>
                            <w-flex justify-center align-center>
                              <div class="xs6">
                                <tr >
                                    <td class="fw-semibold m0">Bandar : &nbsp;&nbsp;&nbsp;</td>
                                    <td>{{form_profil.bandar}}</td>
                                  </tr>
                              </div>
                              <div class="xs6">
                                <tr >
                                    <td class="fw-semibold m0">Negeri :&nbsp;&nbsp;&nbsp;</td>
                                    <td>{{form_profil.negeri}}</td>
                                  </tr>
                              </div>
                            </w-flex><br>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="No. Telefon" 
                              name="No. Telefon" 
                              v-model="form_profil.no_tel" 
                              :validators="[validators.numeric]"/>
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="Emel"  
                              name="Email" 
                              v-model="form_profil.emel"/>
                        </w-flex>
                    </w-form>
                </template>
                <template #actions>
                  <div class="spacer" />
                    <w-button bg-color="grey-light5--bg" @click="dialogProfilNew.show = false">Tutup</w-button>
                    <w-button class="ml1" :loading="dialog.loading" :disabled="dialog.valid === false" @click="$refs.form.validate()">Simpan</w-button>
                </template>
            </w-dialog>

        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {},
    props: {
        id: [Array, Object, String],
    },
    data() {
        return {
            isHidden: false,
            resourceurl: this.service_tunggakan + "perumahan_agensi/agensi",
            reload: true,
            files: [],
            form_profil: {},
            form_cari: {},
            form_cari_pembayar: {},
            carian_profil: { q: "" },
            carian_profil_pembayar: { q: "" },
            profils: [],
            profils_pembayar: [],
            perumahan: [],
            dialogProfil: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 800,
                form: { nama: "", email: "" },
            },
            dialogProfilPembayar: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 800,
                form: { nama: "", email: "" },
            },
            dialogProfilNew: {
                  valid: false,
                  show: false,
                  fullscreen: false,
                  persistent: true,
                  persistentNoAnimation: false,
                  loading: false,
                  width: 800,
                  form: {nama: '', email: ''}
            },
             kategori: [
                {
                    value: 1,
                    label: "Individu",
                },
                {
                    value: 2,
                    label: "Syarikat",
                },
            ],
            form : {
              loading: false,
            },
            loading: false,
            selection: true,
            i_ind : null,
            id : null,
            tabs: [
                { title: "Butiran Bayaran", content: "" },
                { title: "Jejak Audit", content: "" },
            ],
            activeTab : 0,
            crumbs: [
                { label: "iHasil", route: "/" },
                { label: "Perumahan", route: "/perumahan" },
                { label: "Agensi Pembayaran", route: "/perumahan/agensi" },
                { label: "Daftar Potongan Gaji", route: "/perumahan/agensi" + this.id },
            ],
            validators: {
                required: (value) => !!value || "Medan ini wajib diisi",
                consent: (value) => !!value || "You must agree",
                email: (value) =>
                    !!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i) ||
                    "Sila Semak Format Email",
                numeric: (value) => !isNaN(value) || "Medan Ini Wajib Numeric",
            },
        };
    },
    methods: {
        profilNew(){
          this.dialogProfilNew.show = 1
        },
        submitProfilNew() {
        
            if (this.dialog.valid == true) {
            //     this.form.valid = false

            // if (this.$refs.form.validate()) {
                this.dialog.loading = true

                
                    this.$zcomm.post(this.service_bil_pelbagai+'profil' , this.form_profil)
                        .then(res => {
                          // console.log(res)
                          //update displayed record
                          // this.$page.flash.success = "Rekod telah ditambah"
                          this.mapreturneddata(res)
                          this.dialogProfilNew.show = false;
                          if (typeof this.onAfterAdd === "function") {
                            this.onAfterAdd()
                          }
                          // this.form.profil_id = res.id;
                          // this.form.no_id = res.no_id;
                          // this.form.nama = res.nama;
                          // this.form.alamat1 = res.alamat1;
                          // this.form.alamat2 = res.alamat2;
                          // this.form.alamat3 = res.alamat3;
                          // this.form.poskod = res.poskod;
                          // this.form.bandar = res.bandar;
                          // this.form.negeri = res.negeri;
                          // this.form.kategori = res.kategori;
                            // this.$inertia.visit(this.$page.url)
                          // for (var j in this.perumahan) {
                                // if(this.form.perumahan_id == this.perumahan_id){
                                this.form.pembayar_id = res.id;
                                this.form.pembayar_nama = res.no_id + ' | ' +res.nama;
                                this.form_cari_pembayar = res.id;

                                // }
                            // }
                          
                        })
                        .finally(() => {
                            this.dialog.loading = false;
                          this.dialogProfilNew.show = false;
                          this.dialogProfilPembayar.show = false;
                          
                          // $('#' + this.resourceurl).modal('hide')
                        });
                        this.cariProfil();
                
            }
        },
        profil() {
            this.dialogProfil.show = 1;
        },

        cariProfil() {
            if (this.carian_profil.q.length > 1) {
                this.$zcomm.post(this.service_utiliti + "lookup/profil_perumahan", this.carian_profil,{})
                    .then((res) => {
                        console.log(res);
                        this.profils = res;
                    });
            }
        },

        pilihProfil(dt) {
            this.form_cari.id = dt.value;
            this.profilDetail();
        },
        profilDetail() {
            this.$zcomm
                .get(this.service_tunggakan + "perumahan_agensi/profil" + "?profil_id=" + this.form_cari.id)
                .then((res) => {
                    console.log(res.data);
                    this.loading = false
                    if(res.code > 0){
                        // alert(res.data.perumahan_id);

                        if (res.data) {
                            this.form.perumahan_id = res.data.perumahan_id;
                            this.form.jumlah_amaun_bil = res.data.perumahan.jumlah_amaun_bil;
                            this.form.kadar_potongan = res.data.jumlah_amaun_bil;
                            this.form.jumlah_patut_kutip = res.data.perumahan.amaun_kutipan;
                            this.form.no_akaun = res.data.perumahan.no_akaun;
                            this.form.profil_id = res.data.profil_id;
                            this.form.nama_profil = res.data.nama_id;
                            this.form.jenis_skim = res.data.perumahan.lkp_perumahan_keterangan;
                            this.form.skim_perumahan = res.data.perumahan.no_skim;
                            this.form.kod_premis = res.data.perumahan.kod_premis;
                            this.form.perumahan_potongan_amaun = res.data.perumahan_potongan_amaun;
                            var proses = 1;
                            for (var j in this.form.perum_array) {
                                if(res.data.perumahan_id == this.form.perum_array[j].id){
                                    proses = 0;
                                    this.$zutil.message('Data sudah pilih!', false);
                                    this.dialogProfil.show = false;
                                }
                            }
                            for (var w in this.perumahan) {
                                if(res.data.perumahan_id == this.perumahan[w].perumahan_id){
                                    proses = 0;
                                    this.$zutil.message('Hanya Boleh pilih 1 rekod saja!', false);
                                    this.dialogProfil.show = false;
                                }
                                

                            }
                            if(proses == 1){
                                if(res.data.perumahan.is_potongan_gaji == 1){
                                    proses = 0;
                                    this.$zutil.message('Rekod Sudah Ada Dalam Pejabat Lain!', false);
                                    this.dialogProfil.show = false;
                                }else{

                                // if(res.data > 0){
                                        // this.perumahan.push({
                                        //     perumahan_id: res.data.id,
                                        //     kadar_bulanan: res.data.kadar_bulanan,
                                        //     jumlah_patut_kutip: res.data.amaun_kutipan,
                                        //     no_akaun: res.data.no_akaun,
                                        //     profil_id: res.data.profil.id,
                                        //     nama_profil: res.data.nama_id,
                                        //     jenis_skim: res.data.perumahan.lkp_perumahan_keterangan,
                                        //     skim_perumahan: res.data.no_skim,
                                        //     jumlah_amaun_bil: res.data.jumlah_amaun_bil,
                                        // });
                                        // this.$zutil.message('Berjaya Di pilih');
                                //     }else{
                                        this.perumahan.push({
                                            perumahan_id: res.data.perumahan_id,
                                            kadar_bulanan: res.data.perumahan.kadar_bulanan,
                                            jumlah_patut_kutip: res.data.perumahan.amaun_kutipan,
                                            no_akaun: res.data.perumahan.no_akaun,
                                            profil_id: res.data.profil_id,
                                            nama_profil: res.data.nama_id,
                                            jenis_skim: res.data.perumahan.lkp_perumahan_keterangan,
                                            skim_perumahan: res.data.perumahan.no_skim,
                                            jumlah_amaun_bil: res.data.perumahan.jumlah_amaun_bil,
                                            kod_premis: res.data.perumahan.kod_premis,
                                            kadar_potongan: res.data.perumahan.jumlah_amaun_bil,
                                            perumahan_potongan_amaun: res.data.perumahan.perumahan_potongan_amaun,
                                        });
                                        this.$zutil.message('Berjaya Di pilih');
                                    }
                                // }
                            }
                            // }

                            this.form.perumahan = this.perumahan;
                            this.dialogProfil.show = false;
                        }
                    }else{
                        this.$zutil.message('Rekod tidak ada Bil Potongan Gaji Perumahan', false);
                        this.dialogProfil.show = false;
                    }

                });
        },


        profilPembayar() {
            this.dialogProfilPembayar.show = 1;
        },

        cariProfilPembayar() {
            if (this.carian_profil_pembayar.q.length > 1) {
                this.$zcomm.post(this.service_bil_pelbagai + "lookup/profil", this.carian_profil_pembayar,{})
                    .then((res) => {
                        console.log(res);
                        this.profils_pembayar = res;
                    });
            }
        },

        pilihProfilPembayar(dt) {
            this.form.pembayar_nama = dt.label;
            this.form.pembayar_id = dt.value;
            this.form_cari_pembayar.id = dt.value;
            this.profilDetailPembayar();
        },

        profilDetailPembayar() {
            this.$zcomm
                // .get(this.service_deposit + "profil/" + this.form_cari.id)
                .get(this.service_bil_pelbagai+'profil/'+this.form_cari_pembayar.id)
                // .get(this.service_tunggakan + "perumahan_agensi/profil_pembayar" +  this.form_cari.id)
                .then((res) => {
                    for (var j in this.perumahan) {
                        if(this.perumahan[j].perumahan_id == this.perumahan_id){
                        this.perumahan[j].potongan_profil_id = res.id;
                        this.perumahan[j].potongan_nama = res.no_id + ' | ' +res.nama;
                        }
                    }
                })
                .then((res) => {
                    this.carian_profil.q = null;
                    this.profils_pembayar = null;
                    this.dialogProfilPembayar.show = false;
                });
        },

        removePerumahan(index) {
            this.form.perumahan.splice(index, 1);
        },

        simpan(tindakan) {
            // alert(this.perumahan);
            if(this.form.valid == true){
                this.form.loading = true
                this.form.tindakan = 1;
                this.form.perumahan = this.perumahan;
                    this.$zcomm.post(this.resourceurl + '/simpan/'+this.form.id, this.form)
                    .then((res) => {
                        if (typeof this.onAfterEdit === "function") {
                            this.onAfterEdit();
                        }
                        this.$inertia.visit(this.$route('perumahan-agensi.agensi.show', this.form.id))
                    })
                    .catch((err) => {})
                    .finally(() => {
                            this.$zutil.notify ("Data Berjaya Disimpan.")
                            this.form.loading = false
                    });
            }
        },
        clear () {
            this.getData()
            this.files = false
            this.$nextTick(() => {
                this.files = true
            })
        },
        cekPilih(){
            for (var i in this.form.perum_array) {
                this.form.perum_array[i].pilih = this.pilih
            }
        },

        padam(dt){
            var yakin = confirm("Apakah Anda Yakin?");

            if (yakin) {
                var param = {
                  id : dt.id,
                  perumahan_pejabat_id : this.form.id,
                }
                this.$zcomm
                    .post(this.resourceurl + '/padam/'+this.form.id, param)
                    .then(res => {
                        this.$inertia.visit(this.$route('perumahan-agensi.agensi.show', this.form.id))
                    })
                    .finally(() => {
                      this.$zutil.message('Berjaya Di Padam!', false)
                    });
            } else {
                this.$zutil.notify('Batal Di Padam!', false);
            }
        },


        bayar() {
            var id = '';
            for (var i in this.form.perum_array) {
                if(this.form.perum_array[i].pilih == true){
                        id = this.form.perum_array[i].id+','+id
                }
            }
            if(id){
                window.location.href = 'bayar/'+this.form.id +
                                "?perumahan_id=" +id;
            }else{
                alert('sila pilih dulu.')
            }
        },
        back(){
               this.$inertia.visit(this.$route('perumahan-agensi.agensi.index'));
        }

    },
    watch: {
        files: function (val) {
            // console.log(val);
            console.log("work");
        },
        // "form_cari.id": function (q) {
            // this.profilDetail();
        // },
    },
    mounted() {
        this.dialog.width = 900;
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
